@if (inspectorText) {
  <div class="inspector">{{ inspectorText }}</div>
} @else {
  <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
  <div class="inspector inspector--clickable" (click)="handleClick()">
    Inspector enabled, click to disable
  </div>
}
